import React from 'react';

const SubscriptionErrorGrid = ({ subscriptionResponse }) => {
    if (!subscriptionResponse || subscriptionResponse.status !== 'ERROR') {
        return <div>No error response found.</div>
    }

    return (
        <div className="error-response-grid">
            <h3 style={{ color: 'red', fontWeight: 'bold' }}>
                Error: {subscriptionResponse.message}
            </h3>

            <table>
                <thead>
                    <tr>
                        <th>Subscription Type</th>
                        <th>Subscription Value</th>
                        <th>Status</th>
                        <th>Status Message</th>
                    </tr>
                </thead>
                <tbody>
                    {subscriptionResponse.subscriptionList.map((subscription, index) => (
                        <tr key={index}>
                            <td>{subscription.subscriptionType}</td>
                            <td>{subscription.subscriptionValue}</td>
                            <td>{subscription.status}</td>
                            <td>{subscription.statusMessage}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div >
    );
};

export default SubscriptionErrorGrid;
